import type {FunctionComponent} from "react";
import {WarningOutlined} from "@mui/icons-material";
import type {ToastContentProps} from "react-toastify";
import ToastContent from "../../index";

export interface IWarningToastContent {
    message: string,
    title?: string,
}

const WarningToastContent: FunctionComponent<ToastContentProps<IWarningToastContent>> = (props) => {

    return (
        <>
            <ToastContent
                title={props.data.title}
                message={props.data?.message ?? ''}
                icon={<WarningOutlined color={'warning'}/>}
                className={typeof props.toastProps.className === 'string' ? props.toastProps.className : ''}
                toastProps={props.toastProps}
            />
        </>
    )
}

export default WarningToastContent;
